export const fmtBRL = (v, decimals = 0) => {
  if (v === null || v === undefined) return '—';
  return v.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const REGIME_OPTIONS = [
  { value: 'pessoa_fisica', label: 'Pessoa Física (recebo como autônomo/PF)' },
  { value: 'simples_nacional', label: 'Simples Nacional' },
  { value: 'lucro_presumido', label: 'Lucro Presumido' },
  { value: 'lucro_presumido_sup', label: 'Lucro Presumido — Sociedade Uniprofissional (SUP)' },
  { value: 'equiparacao_hospitalar', label: 'Lucro Presumido — Equiparação Hospitalar' },
  { value: 'nao_sei', label: 'Não sei / Outro' },
];

export const REGIME_LABELS = REGIME_OPTIONS.reduce((acc, o) => ({ ...acc, [o.value]: o.label }), {});

export const SERVICE_OPTIONS = [
  { value: 'consultas', label: 'Consultas' },
  { value: 'procedimentos_cirurgicos', label: 'Procedimentos cirúrgicos' },
  { value: 'exames', label: 'Exames' },
  { value: 'hospitais_terceiros', label: 'Atendimento em hospitais de terceiros' },
  { value: 'pronto_atendimento', label: 'Serviço de pronto atendimento' },
  { value: 'outra_nao_medica', label: 'Outra categoria não médica' },
];

export const PROFESSION_OPTIONS = [
  { value: 'dentista', label: 'Dentista' },
  { value: 'fisioterapeuta', label: 'Fisioterapeuta' },
  { value: 'fonoaudiologo', label: 'Fonoaudiólogo' },
  { value: 'psicologo', label: 'Psicólogo' },
  { value: 'terapia_ocupacional', label: 'Terapeuta Ocupacional' },
];

export const SERVICE_LABELS = SERVICE_OPTIONS.reduce((acc, o) => ({ ...acc, [o.value]: o.label }), {});
export const PROFESSION_LABELS = PROFESSION_OPTIONS.reduce((acc, o) => ({ ...acc, [o.value]: o.label }), {});

export const onlyDigits = (s) => (s || '').replace(/\D/g, '');

export const displayMoney = (d) => (d ? Number(d).toLocaleString('pt-BR') : '');

export const maskPhone = (v) => {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
